/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Directory_SubtitleInputs */

const vi_meeting_guest_directory_subtitle = /** @type {(inputs: Meeting_Guest_Directory_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách ngoài hệ thống tới làm việc với HTX. Sửa tên ở đây đổi luôn tên hiển thị trong mọi cuộc họp cũ; chức vụ thì không, vì mỗi cuộc họp giữ chức vụ riêng tại thời điểm đó.`)
};

/**

* @param {Meeting_Guest_Directory_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_directory_subtitle = /** @type {((inputs?: Meeting_Guest_Directory_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Directory_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_directory_subtitle(inputs)
});